import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../../Assets/home-main.png";
import Particle from "../Particle";
import Home2 from "./Home2";
import Type from "./Type";
import Techstack from "../About/Techstack";
import {
  AiFillGithub,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import laptopImg from "../../Assets/about.png";
import { MdOutlineMailOutline } from "react-icons/md";
function Home() {
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Hi There!{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1>

              <h1 className="heading-name">
                I'M
                <strong className="main-name"> Tianyang Chen</strong>
              </h1>

              <div style={{ padding: 50, textAlign: "left" }}>
                <Type />
              </div>
            </Col>

            <Col md={5} style={{ paddingBottom: 20 }}>
              <img
                src={homeLogo}
                alt="home pic"
                className="img-fluid"
                style={{ maxHeight: "450px" }}
              />
            </Col>
          </Row>
        </Container>
      </Container>
      <Home2 />
      <Container fluid className="about-section">
        <Particle />
        <Container>
          <Row style={{ justifyContent: "center", padding: "10px" }}>
            <Col
              md={8}
              style={{
                justifyContent: "center",
                paddingTop: "30px",
                paddingBottom: "50px",
              }}
            >
              <h1 style={{ textAlign: "left" }}>
                <strong className="purple"> Work Experience</strong>
              </h1>
              <br />
              <Row>
                <Col xs={12} md={4} style={{ textAlign: "left" }}>
                  <div className="d-md-none">
                    Oct. 2022 - Present
                    <br />
                    <strong className="purple">Microsoft</strong> - Software Engineer II
                    <br />
                    <br />
                    Jul. 2018 - Oct. 2022
                    <br />
                    <strong className="purple">Unified Patents</strong> - Full Stack Software Engineer
                    <br />
                    <br />
                    Feb. 2018 - May. 2018
                    <br />
                    <strong className="purple">TuSimple</strong> - Sensor Engineer Intern
                    <br />
                    <br />
                    Jul. 2017 - Aug. 2017
                    <br />
                    <strong className="purple">DxChainNetwork</strong> - Software Engineer Intern
                    <br />
                    <br />
                  </div>
                  <div className="d-none d-md-block">
                    Oct. 2022 - Present
                    <br />
                    <br />
                    Jul. 2018 - Oct. 2022
                    <br />
                    <br />
                    Feb. 2018 - May. 2018
                    <br />
                    <br />
                    Jul. 2017 - Aug. 2017
                    <br />
                    <br />
                  </div>
                </Col>
                <Col xs={12} md={8} style={{ textAlign: "left" }}>
                  <div className="d-none d-md-block">
                    <strong className="purple">Microsoft</strong> - Software Engineer II
                    <br />
                    <br />
                    <strong className="purple">Unified Patents</strong> - Full Stack Software Engineer
                    <br />
                    <br />
                    <strong className="purple">TuSimple</strong> - Sensor Engineer Intern
                    <br />
                    <br />
                    <strong className="purple">DxChainNetwork</strong> - Software Engineer Intern
                    <br />
                    <br />
                  </div>
                </Col>
              </Row>
              <h1 style={{ textAlign: "left" }}>
                <strong className="purple"> Education</strong>
              </h1>
              <br />
              <Row>
                <Col xs={12} md={4} style={{ textAlign: "left" }}>
                  <div className="d-md-none">
                    Aug. 2016 - May 2018
                    <br />
                    <strong className="purple">University of Arizona </strong> - MS in Electrical and Computer Engineering
                    <br />
                    <br />
                    Sep. 2012 - Jun. 2016
                    <br />
                    <strong className="purple">Huazhong University of Science & Technology</strong> - BS in Optoelectronic Information Engineering
                    <br />
                    <br />
                  
                  </div>
                  <div className="d-none d-md-block">
                    Aug. 2016 - May 2018
                    <br />
                    <br />
                    Sep. 2012 - Jun. 2016
                    <br />
                    <br />
                  </div>
                </Col>
                <Col xs={12} md={8} style={{ textAlign: "left" }}>
                  <div className="d-none d-md-block">
                  <strong className="purple">University of Arizona </strong> - MS in Electrical and Computer Engineering
                    <br />
                    <br />
                    <strong className="purple">Huazhong University of Science & Technology</strong> - BS in Optoelectronic Information Engineering
                    <br />
                    <br />
                  </div>
                </Col>
              </Row>
            </Col>
            <Col
              md={4}
              style={{ paddingTop: "120px", paddingBottom: "50px" }}
              className="about-img"
            >
<img src={laptopImg} alt="about" className="img-fluid" />
            </Col>
          </Row>
          <h1 className="project-heading">
            Professional <strong className="purple">Skillset </strong>
          </h1>

          <Techstack />
          <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/tianyangChen/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="mailto:tenyo.chen@gmail.com"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <MdOutlineMailOutline />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/tianyang-chen/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/tenyo.chen"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
        </Container>
      </Container>

    </section>
  );
}

export default Home;
